import { render, staticRenderFns } from "./EventsTable.vue?vue&type=template&id=6497a3d1&"
import script from "./EventsTable.vue?vue&type=script&lang=ts&"
export * from "./EventsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports